import React, { Component } from "react";

import HomePage from './home/HomePage';

import "./SinglePage.scss";

export default class SinglePage extends Component<{}, {}> {

    render() {
        return (
            <React.Fragment>
                <HomePage/>
                {/* <ProjectsPage/>
                <AboutPage/>
                <ContactPage/> */}
            </React.Fragment>
        );
    }
}